// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

// lib
import User from '../../lib/User.js'

// Styles
import './styles.scss'

class PixelAudiencesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      companies: [],
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  componentDidMount() {
    User.watch(this, () => {
      this.loadCompanies()
    })
  }

  loadCompanies = () => {
    window._api.get('/companies', (error, resp) => {
      if (error) {
        toast.error(error.message)
      }
      this.setState({ companies: resp.items })
    })
  }

  render() {
    let { companies, modalOpen } = this.state

    return (
      <div id="pixel-audiences-page">
        <Header
          title="Pixel Audiences"
          actions={[
            {
              children: 'Create New Audience',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              key: 'name',
              link: '/pixel-audiences/:_id',
              name: 'Name',
              sortable: true,
            },
            {
              name: 'Client',
              key: 'client.name',
            },
            {
              name: 'Redirect',
              key: 'redirect',
            },
            {
              format: 'date',
              key: 'updated_at',
              name: 'Last Updated',
              sortable: true,
            },
          ]}
          entities="pixel-audiences"
          filters={[
            { name: 'company', options: companies, className: 'pixel-audiences__companies' },
          ]}
          fields={['name', 'client.name', 'redirect', 'updated_at']}
          search={this.search}
          searchable={true}
          sort_dir={-1}
          sort_key={'updated_at'}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="pixel-audiences"
            title="Enter a name for your new Pixel Audience"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default PixelAudiencesPage
